module.exports = __webpack_public_path__ + "static/media/Mobile_Data_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.11d0f138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/ibm/Mobile_Data_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.png
// module id = 82
// module chunks = 0